import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']
  static classes = ['open']

  connect() {
    this.isOpen = false

    // Bind the close method to preserve 'this' context
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('click', this.closeOnOutsideClick)
    document.removeEventListener('touchstart', this.closeOnOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    if (this.isOpen) return

    this.isOpen = true
    this.menuTarget.style.display = 'block'
    this.menuTarget.style.opacity = '0'
    this.menuTarget.style.transform = 'translateY(10px)'

    // Force reflow
    this.menuTarget.offsetHeight

    // Animate in
    this.menuTarget.style.transition = 'all 0.15s ease-out'
    this.menuTarget.style.opacity = '1'
    this.menuTarget.style.transform = 'translateY(0)'

    // Add outside click listeners after a small delay to prevent immediate closing
    setTimeout(() => {
      document.addEventListener('click', this.closeOnOutsideClick)
      document.addEventListener('touchstart', this.closeOnOutsideClick)
    }, 100)
  }

  close() {
    if (!this.isOpen) return

    this.isOpen = false
    this.menuTarget.style.transition = 'all 0.15s ease-in'
    this.menuTarget.style.opacity = '0'
    this.menuTarget.style.transform = 'translateY(10px)'

    setTimeout(() => {
      if (!this.isOpen) {
        // Double check in case it was reopened
        this.menuTarget.style.display = 'none'
      }
    }, 150)

    // Remove outside click listeners
    document.removeEventListener('click', this.closeOnOutsideClick)
    document.removeEventListener('touchstart', this.closeOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    // Don't close if clicking inside the dropdown
    if (this.element.contains(event.target)) {
      return
    }

    this.close()
  }

  // Handle menu item clicks
  menuItemClick(event) {
    // Allow the original click to proceed but close the dropdown
    setTimeout(() => {
      this.close()
    }, 10)
  }
}
